// 运营单元操作类型
export enum OuOperationType {
  // 添加为管理员
  ADMINISTRATOR = 1,
  // 添加为成员
  MEMBER,
  //  移除
  REMOVE,
}

export const OuOperationTypeDisplay = {
  [OuOperationType.ADMINISTRATOR]: '添加为管理员',
  [OuOperationType.MEMBER]: '添加为成员',
  [OuOperationType.REMOVE]: '移除权限',
};

// 组织数据权限类型
export enum OrgDataPermissionType {
  // 添加
  ADD = 1,
  // 移除
  REMOVE,
}

export const OrgDataPermissionTypeDisplay = {
  [OrgDataPermissionType.ADD]: '添加',
  [OrgDataPermissionType.REMOVE]: '移除',
};
